import { useState, useTransition } from 'react';
import { useSearchParams } from 'react-router';
import { useDebounce } from 'react-use';

export const useBlogSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchInputValue, setSearchInputValue] = useState(
    searchParams.get('search') || ''
  );
  const [isPending, startTransition] = useTransition();
  useDebounce(
    () => {
      startTransition(() => {
        if (searchInputValue) {
          setSearchParams({ search: searchInputValue });
        } else {
          setSearchParams(prevParams => {
            prevParams.delete('search');
            return prevParams;
          });
        }
      });
    },
    300,
    [searchInputValue, setSearchParams]
  );

  return { searchInputValue, isPending, setSearchInputValue };
};
